import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-content-loader',
  templateUrl: './content-loader.component.html',
  styles: []
})
export class ContentLoaderComponent implements OnInit {

  @Input() isContentLoading = false;

  constructor() { }

  ngOnInit() {
  }

}
